/* eslint-disable no-alert */
import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { Label, Grid, Segment, Table, Header, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import Loading from '../../components/common/loading'
import DateFields from '../../components/driverIncentive/inputDate'
import DriverIncentiveActions from '../../reducers/driverIncentiveReducer'
import DriverSegmentActions from '../../reducers/driverSegmentReducer'

class DriverIncentive extends Component {
  state = {
    startFrom: null,
    endAt: null
  }

  componentDidMount() {
    const { syncDriverSegments } = this.props
    const startFrom = moment().subtract(1, 'weeks').startOf('day').format('x')
    const endAt = moment().endOf('day').format('x')

    this.setState({ startFrom: Number(startFrom), endAt: Number(endAt) })

    syncDriverSegments()
  }

  componentWillUnmount() {
    const { resetDrivers } = this.props

    resetDrivers()
  }

  onFieldChange = (field, value) => {
    let newValue = value

    if (field === 'startFrom') {
      newValue = moment(value)
        .startOf('day')
        .format('x')
    } else {
      newValue = moment(value)
        .endOf('day')
        .format('x')
    }

    this.setState({ [field]: Number(newValue) })
  }

  onSearch = () => {
    const { getDriver, match, driverSegments } = this.props
    const { startFrom, endAt } = this.state
    const segmentId = match.params.id
    const driverSegment = driverSegments[segmentId]

    getDriver(driverSegment, startFrom, endAt)
  }

  renderDrivers = () => {
    const { drivers } = this.props

    return _.map(drivers, driver => (
      this.renderDriverRow(driver)
    ))
  }

  renderDriverRow = driver => {
    const name = `${driver.family_name} ${driver.first_name}`
    const avgOnlineDuration = _.meanBy(Object.values(driver.performances), 'duration')
    const completedOrder = _.sumBy(Object.values(driver.performances), 'deliveredOrderCount')

    const ratingCount = driver.rating_count || 0
    const reviewerCount = driver.reviewers || 0

    const rating = ratingCount / reviewerCount

    return (
      <Table.Row style={{ fontWeight: 'bold' }} key={driver.uid} >
        <Table.Cell>{name}</Table.Cell>
        <Table.Cell>
          <Label>{driver.tel}</Label>
        </Table.Cell>
        <Table.Cell>{moment.duration(avgOnlineDuration, "milliseconds").format("h [hrs] m [min]")}</Table.Cell>
        <Table.Cell>{completedOrder}</Table.Cell>
        <Table.Cell>{Number.isNaN(rating) ? 0 : rating.toFixed(2)}/{reviewerCount}</Table.Cell>
        <Table.Cell>{driver.totalIncentive.toFixed(2) || 0}</Table.Cell>
      </Table.Row>
    )
  }

  onAddIncentive = () => {
    const { drivers, auth } = this.props
    const { startFrom, endAt } = this.state
    const updates = {}

    const confirmation = window.confirm('Are you sure you want to add incentives to driver?')

    if (!confirmation) return

    _.forEach(drivers, driver => {
      if (driver.totalIncentive > 0) {
        const driverUid = driver.tel
        const creditKey = firebase.database().ref(`deliverer_credits/${driverUid}`).push().key

        updates[`deliverer_credits/${driverUid}/${creditKey}`] = {
          value: Number(parseFloat(driver.totalIncentive).toFixed(2)),
          created_at: firebase.database.ServerValue.TIMESTAMP,
          updated_at: firebase.database.ServerValue.TIMESTAMP,
          description: `Weekly Incentive from ${moment(parseInt(startFrom, 10)).format('YYYY-MM-DD')} to ${moment(parseInt(endAt, 10)).format('YYYY-MM-DD')}`,
          auto_calculate: true,
          type: 'deposit',
          handler: auth.email,
        }
      }
    })

    firebase.database().ref().update(updates).then(err => {
      if (err) {
        alert(err)
      } else {
        alert('Successfully add incentive!')
      }
    })
  }

  renderTotalIncentive = () => {
    const { drivers } = this.props
    let totalIncentive = 0

    _.map(drivers, driver => {
      totalIncentive += driver.totalIncentive
    })

    return (
      <Table.Row style={{ fontWeight: 'bold' }}>
        <Table.Cell></Table.Cell>
        <Table.Cell></Table.Cell>
        <Table.Cell></Table.Cell>
        <Table.Cell></Table.Cell>
        <Table.Cell>Total</Table.Cell>
        <Table.Cell>{totalIncentive.toFixed(2)}</Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const { loading, driverSegments, drivers, match} = this.props
    const { startFrom, endAt } = this.state
    const segmentId = match.params.id
    const segmentName = _.size(driverSegments) > 0 ? driverSegments[segmentId].name : ''
    const disabled = _.size(drivers) === 0

    return (
      <div>
        <Loading active={loading} />
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <Header size="large" style={{ display: 'inline-block', width: '100%' }}>
                Segment &quot;{segmentName}&quot;
                <Button style={{ float: 'right' }} disabled={disabled} onClick={this.onAddIncentive}>Add Incentive</Button>
              </Header>
              <div>
                <DateFields startFrom={startFrom} endAt={endAt} onSearch={this.onSearch} onFieldChange={this.onFieldChange} />
                <Table columns={6}>
                  <Table.Header>
                    <Table.Row style={{ fontWeight: 'bold' }}>
                      <Table.Cell>Name</Table.Cell>
                      <Table.Cell>Phone</Table.Cell>
                      <Table.Cell>Avg Online Per Day</Table.Cell>
                      <Table.Cell>Completed Order</Table.Cell>
                      <Table.Cell>Rating</Table.Cell>
                      <Table.Cell>Incentive amount</Table.Cell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    { this.renderDrivers() }
                    {
                     (_.size(drivers) > 0 ) && this.renderTotalIncentive()
                    }
                  </Table.Body>
                </Table>
              </div>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ driverIncentives, driverSegments, auth }) => ({
  auth: auth.data,
  drivers: driverIncentives.driversInSegment,
  loading: driverIncentives.loading,
  driverSegments: driverSegments.driverSegments,
  driverSegmentLoading: driverSegments.driverSegmentLoading
})

const mapDispatch = {
  getDriver: DriverIncentiveActions.syncDriversBySegment,
  syncDriverSegments: DriverSegmentActions.syncDriverSegments,
  resetDrivers: DriverIncentiveActions.resetDrivers
}

export default connect(
  mapState,
  mapDispatch
)(DriverIncentive)



// WEBPACK FOOTER //
// ./src/containers/driverIncentive/index.js